/**
 * B.7.e — `/admin/portals/new` — operator-only portal-creation wizard.
 *
 * Renders the four-step `WizardShell`. The role gate is enforced inside
 * the shell (so non-operators see a 403 affordance rather than a blank
 * route).
 */

import { createFileRoute } from '@tanstack/react-router';
import { WizardShell } from '../../../components/portal-wizard/WizardShell';

export const Route = createFileRoute('/admin/portals/new')({
  component: PortalWizardPage,
});

function PortalWizardPage() {
  return <WizardShell />;
}
